import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useSnackbar from 'shared/hooks/useSnackbar';
import { TokenConfig } from './types';

export const useTokens = (config: TokenConfig) => {
  const { openSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const {
    data: tokens,
    isLoading,
    error,
  } = useQuery(config.queryKey, () => config.api.getTokens());

  const {
    mutateAsync: createToken,
    isLoading: isCreating,
    error: createError,
  } = useMutation(
    (data: {
      description: string;
      expiresInMinutes?: number;
      roleIds?: string[];
    }) => config.api.createToken(data),
    {
      onSuccess: () => {
        openSnackbar({
          message: config.successMessages.create,
          variant: 'success',
        });
        queryClient.invalidateQueries(config.queryKey);
      },
      onError: (error: any) => {
        openSnackbar({
          message: error?.message || config.successMessages.createError,
          variant: 'error',
        });
      },
    },
  );

  const { mutateAsync: deleteToken, isLoading: isDeleting } = useMutation(
    (tokenId: string) => config.api.deleteToken(tokenId),
    {
      onSuccess: () => {
        openSnackbar({
          message: config.successMessages.delete,
          variant: 'success',
        });
        queryClient.invalidateQueries(config.queryKey);
      },
      onError: (error: any) => {
        openSnackbar({
          message: error?.message || config.successMessages.deleteError,
          variant: 'error',
        });
      },
    },
  );

  return {
    tokens,
    isLoading,
    error,
    createToken,
    isCreating,
    createError,
    deleteToken,
    isDeleting,
  };
};
